import i18n from 'i18next';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';
import en from '../languages/en-EN.json';
import ru from '../languages/ru-RU.json';
import uz from '../languages/uz-UZ.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    ru: {
      translation: ru,
    },
    uz: {
      translation: uz,
    },
  },
  lng: 'ru',
  fallbackLng: 'ru',
  keySeparator: false,

  interpolation: {
    escapeValue: false,
  },
  react: {
    wait: true,
  },
});

moment.locale('ru');

export default i18n;
